"use client";

import { useState, FormEvent } from "react";
import { useRouter } from "next/navigation";
import { Search } from "lucide-react";

const popularSearches = [
  "야마하 바이올린",
  "어쿠스틱 기타",
  "SM57 마이크",
  "미디키보드",
  "전자드럼",
  "오디오 인터페이스",
  "일렉기타",
  "신디사이저",
];

export default function SearchSection() {
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (query: string = searchQuery) => {
    if (!query.trim()) return;
    router.push(`/list?keyword=${encodeURIComponent(query.trim())}`);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSearch();
  };

  const handlePopularSearchClick = (query: string) => {
    setSearchQuery(query);
    handleSearch(query);
  };

  return (
    <section className="relative overflow-hidden bg-white text-gray-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-24 py-16 sm:py-20 lg:py-24">
        {/* 섹션 헤더 */}
        <div className="text-center mb-10 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-[-0.02em] mb-4 text-gray-900">
            어떤 악기를 찾고 있나요?
          </h2>
        </div>

        {/* 검색 입력 영역 */}
        <div className="max-w-2xl mx-auto mb-8 sm:mb-10">
          <form onSubmit={handleSubmit} className="relative">
            <div className="relative flex items-center">
              {/* 검색 아이콘 */}
              <div className="absolute left-4 sm:left-6 z-10 text-gray-400">
                <Search className="w-5 h-5 sm:w-6 sm:h-6" />
              </div>

              {/* 검색 입력창 */}
              <input
                type="text"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="존재하는 모든 악기 모델을 검색해보세요"
                className="w-full pl-12 sm:pl-14 pr-32 sm:pr-36 py-4 sm:py-5 text-base sm:text-lg rounded-full border-2 border-gray-200 bg-gray-50 focus:outline-none focus:border-blue-500 focus:bg-white focus:shadow-lg transition-all duration-200 placeholder:text-gray-400"
              />

              {/* 검색 버튼 */}
              <button
                type="submit"
                className="absolute right-2 sm:right-3 px-6 sm:px-8 py-2.5 sm:py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105 active:scale-95 text-sm sm:text-base"
              >
                검색
              </button>
            </div>
          </form>
        </div>

        {/* 인기 검색어 */}
        <div className="max-w-4xl mx-auto">
          <p className="text-sm sm:text-base text-gray-600 text-center mb-4 sm:mb-6">
            인기 검색어
          </p>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 overflow-x-auto pb-2 sm:pb-0 scrollbar-hide">
            {popularSearches.map((search, index) => (
              <button
                key={index}
                onClick={() => handlePopularSearchClick(search)}
                className="px-4 sm:px-5 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-gray-700 bg-gray-100 hover:bg-blue-100 hover:text-blue-700 rounded-full border border-gray-200 hover:border-blue-300 transition-all duration-200 whitespace-nowrap transform hover:scale-105 active:scale-95"
              >
                {search}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

